
import * as React from 'react';
import {useEffect, useState} from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import {
  Divider,
  IconButton,
  Select,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Grid,
  FormHelperText
} from '@mui/material';
import { printVariable } from '@util/helper';
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import moment from 'moment';
import useDelegate from "@hooks/useDelegate";
import {styled} from "@mui/material/styles";
import useAlert from "@hooks/useAlert";
import ConfirmDialog from "@components/ConfirmDialog";
import { useExpanded } from 'react-table';
import Linker from '@components/Linker';

const ManagerMessageSmsPartView = ({record, dialogHandler}) => {
  const content = record.content
  return (
    <div style={{whiteSpace:'pre-line'}}>
      <Linker>{content}</Linker>
      <div style={{marginTop:10}}></div>
      {
        record.attchList && record.attchList.map((item, index) =>(
          item.fileType.includes('image') ? (
            <div key={index} style={{padding:10}}>
              <img src={`/scm/repo/${item.fileLoc}`} style={{width:'100%'}}/>
            </div>
          ) : null
        ))
      }
      <Divider />
      <div style={{display:'flex', justifyContent:'center', marginTop:20}}>
        <Button onClick={() => dialogHandler[1](false)} >
          닫기 
        </Button>
      </div>
    </div>
  )
}

export default ManagerMessageSmsPartView
